/*
 * Desktop mega menu, design A "clean columns" (snippets/header-menu.liquid,
 * snippets/nav-hub-shell.liquid, styles in nav-home-redesign.css).
 *
 * A hub opens on hover after a short intent delay, or on click/Enter, and closes
 * on Escape, when focus or the pointer leaves it, or on a click on the dimmed
 * overlay. Only classes and aria-expanded change here; everything visual is CSS.
 *
 * Two hover details matter for shoppers. Switching from an open hub to another
 * waits SWITCH_DELAY: the hub buttons fill the nav row, so a diagonal move from a
 * button to its panel's right-hand columns crosses the next button, and switching
 * at once opened the wrong panel. And a click on a hub that hover has already
 * opened keeps it open (people click the label they point at); a second click
 * closes it.
 *
 * The one measurement is the nav's bottom edge, read when a panel opens (and on
 * scroll while one is open), so the overlay and the panel's max-height start
 * under the header wherever it sits. Nothing is measured at load.
 */
(function () {
  var OPEN_DELAY = 110;
  var SWITCH_DELAY = 220;
  var CLOSE_DELAY = 180;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var overlay = root.querySelector('[data-mega-overlay]');
    var items = root.querySelectorAll('[data-mega-item]');
    var current = null;
    var openTimer;
    var closeTimer;
    var openedByHover = false;
    // A tap also fires mouseenter/mouseleave, which opened or closed panels behind
    // the tap's back (tapping a second hub closed it again). Touch works by taps
    // alone; a real mouse moving switches hover back on.
    var touching = false;

    root.addEventListener(
      'pointerdown',
      function (event) {
        touching = event.pointerType !== 'mouse';
      },
      true
    );
    root.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType === 'mouse') touching = false;
      },
      true
    );

    function place() {
      var bottom = Math.round(root.getBoundingClientRect().bottom);
      root.style.setProperty('--smp-mega-top', bottom + 'px');
    }

    function open(item) {
      clearTimeout(closeTimer);
      if (current === item) return;
      if (current) close(current);
      place();
      item.classList.add('is-open');
      item.querySelector('[data-mega-trigger]').setAttribute('aria-expanded', 'true');
      root.classList.add('has-open');
      current = item;
    }

    function close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      item.querySelector('[data-mega-trigger]').setAttribute('aria-expanded', 'false');
      if (current === item) {
        current = null;
        root.classList.remove('has-open');
      }
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');

      item.addEventListener('mouseenter', function () {
        if (touching) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (current === item) return;
        // Crossing another hub's button on the way to the open panel must not switch
        // panels: the pointer only switches once it rests on the button.
        openTimer = setTimeout(function () {
          open(item);
          openedByHover = true;
        }, current ? SWITCH_DELAY : OPEN_DELAY);
      });

      // Closes whichever hub is open, not just this one: leaving a button that was
      // only crossed (so never opened) must still close the panel left behind.
      item.addEventListener('mouseleave', function () {
        if (touching) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          close(current);
        }, CLOSE_DELAY);
      });

      trigger.addEventListener('click', function () {
        clearTimeout(openTimer);
        if (item.classList.contains('is-open') && !openedByHover) {
          close(item);
        } else {
          open(item);
        }
        openedByHover = false;
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && item.classList.contains('is-open')) {
          close(item);
          trigger.focus();
        }
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close(item);
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        close(current);
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (current) place();
      },
      { passive: true }
    );
  }

  document.querySelectorAll('[data-smp-mega]').forEach(init);
})();
